import { CollectionListSnakeCase } from '../types';

const convertCollectionListItem = (data: CollectionListSnakeCase[]) => {
  return data.map((item) => {
    return {
      id: item.id,
      title: item.title,
      scraps: item.scraps,
      likeCount: item.like_count,
      viewCount: item.view_count,
      scrappedCount: item.scrapped_count,
      isFixed: !!item?.is_fixed,
      thumbnail: item.thumbnail,
      thumbnailMainColor: item.thumbnail_main_color,
      isPublic: item.is_public,
      profile: {
        id: item.profile.id,
        image: item.profile.image,
        name: item.profile.name,
        role: item.profile.role,
        roleKor: item.profile.role_kor,
      },
    };
  });
};

export default convertCollectionListItem;
